import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ResetDocumentTabEventService } from '../../document/reset-document-tab-event.service';
import { RelatedDocument } from './related-doc.model';
import { PostHogService } from '@icullen/api/shared';

@Component({
  selector: 'related-doc',
  templateUrl: './related-doc.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedDocComponent implements OnInit {
  @Input() relatedDoc: RelatedDocument;
  @Input() relationType: string;

  constructor(
    private resetDocumentTabService: ResetDocumentTabEventService,     
    private analytics: PostHogService)
  {}

  ngOnInit() {

  }

  private emitResetDocumentTabEvent() {
    this.resetDocumentTabService.emitResetDocumentTabEvent();
  }

  private trackContentTeaserClick() { // storing the traffic_source of the click
    if(this.relationType == "unknown"){
      console.warn("relationType is unknown");
    }
    const containerType = 'related-doc-'+this.relationType;

    console.log('teaser clicked from ' + containerType);

    this.analytics.setNextContentAccess({
      traffic_source: containerType,
    });
  }

  onClick(){
    this.emitResetDocumentTabEvent();
    this.trackContentTeaserClick();
  }
}
